import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import { useNavigate, Link } from 'react-router-dom';
import Footer from './Footer.js';
import { Spinner, Alert } from 'react-bootstrap';
import { BASE_URL } from './Constants.js';

const Manage_DressColor = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [user, setUser] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const fetchProfile = async () => {
      try {
        const response = await fetch(`${BASE_URL}profile`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const data = await response.json();
        setUser(data.profile.is_uniform_access_given);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}dress_colors`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch dress colors');
        }

        const data = await response.json();
        if (data && data.dressColors && Array.isArray(data.dressColors)) {
          const activeDressColors = data.dressColors.filter(color => color.status === 'A');
          setUsers(activeDressColors);
          setFilteredUsers(activeDressColors);
        } else {
          setError('No dress colors found');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    if (query === '') {
      setFilteredUsers(users);
    } else {
      const filteredData = users.filter((user) =>
        (user.dress_color || '').toLowerCase().includes(query) ||
      (user.dress_type || '').toLowerCase().includes(query) ||
      (user.dress_size || '').toLowerCase().includes(query)
      );
      setFilteredUsers(filteredData);
      setCurrentPage(1);
    }
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleDelete = (id) => {
    const confirmDelete = window.confirm(`Are you sure you want to deactivate this dress color?`);
    if (confirmDelete) {
      const token = localStorage.getItem('authToken');
      const formData = new FormData();
      formData.append('id', id);

      fetch(`${BASE_URL}delete_dresscolor`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            window.location.reload();
          } else {
            alert('Failed to deactivate the dress color.');
          }
        })
        .catch(() => alert('Error deactivating the dress color.'));
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  if (loading) {
    return (
      <div className="loading-container">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <Alert variant="danger">{error}</Alert>
      </div>
    );
  }

  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };

  return (
    <div className="page-wrapper">
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div className="page-container" style={{
        marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '300px' : '0',
        transition: 'margin-left 0.3s ease',
      }}>
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">

                  <div className="row">
                    <div className="col-lg-2">
                      <select
                        className="form-control"
                        value={itemsPerPage}
                        onChange={handleItemsPerPageChange}
                      >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                      </select>
                    </div>

                    <div className="col-lg-7">
                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search Dress Color"
                          value={searchQuery}
                          onChange={handleSearch}
                        />
                      </div>
                    </div>

                    <div className="col-lg-2">
                      {user === 'Y' && (
                        <button
                          className="btn btn-primary btn-lg"
                          onClick={() => navigate('/add_dresscolor')}
                        >
                          <i className="fas fa-plus"></i> Add Dress Color
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="table-responsive table--no-card m-b-30">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>S/N</th>
                          <th>Dress Color</th>
                          <th>Dress Type</th>
                          <th>Dress Size</th>
                          <th>Gender</th>
                          <th>Edit</th>
                          <th>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentUsers.length > 0 ? (
                          currentUsers.map((user, index) => (
                            <tr key={user.id}>
                              <td>{indexOfFirstItem + index + 1}</td>
                              <td>{user.dress_color}</td>
                              <td>{user.dress_type}</td>
                              <td>{user.dress_size}</td>
                              <td>{user.gender}</td>
                              <td>
                                <Link to={`/get_dress_colors/${user.id}`}>
                                  <i className="fa fa-edit" style={{ fontSize: '12px', color: 'green' }}></i>
                                </Link>
                              </td>
                              <td style={{ textAlign: 'center' }}>
                                <button
                                  onClick={() => handleDelete(user.id)}
                                  style={{ color: 'red' }}
                                >
                                  <i className="fas fa-trash-alt" style={{ fontSize: '18px' }}></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" className="text-center">
                              No dress colors found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="d-flex justify-content-center mt-3">
                    <button
                      onClick={() => setCurrentPage(currentPage - 1)}
                      disabled={currentPage === 1}
                      className="btn btn-sm btn-outline-secondary mx-1"
                    >
                      Prev
                    </button>

                    {[...Array(totalPages).keys()].map((pageNumber) => (
                      <button
                        key={pageNumber}
                        onClick={() => paginate(pageNumber + 1)}
                        className={`btn btn-sm ${
                          currentPage === pageNumber + 1 ? 'btn-primary' : 'btn-outline-secondary'
                        } mx-1`}
                      >
                        {pageNumber + 1}
                      </button>
                    ))}

                    <button
                      onClick={() => setCurrentPage(currentPage + 1)}
                      disabled={currentPage === totalPages || totalPages === 0}
                      className="btn btn-sm btn-outline-secondary mx-1"
                    >
                      Next
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Manage_DressColor;
